// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2ZF5f","buttons":"RemoveExpirationActionButtons_buttons__3N0EO"};